import React from 'react';
import CompanyRowComponent from './CompanyRow';
import { RootState } from '../../../../../store';
import { useSelector } from 'react-redux';
import helpers from '../../../../../common/helpers/common';
import Handler from '../../../../AM/AM042/presenter/handler/Handler';
import { ReSummarySubmittedMaterialCostProjectSummaryResults } from '../../entity/Entity';

interface props {
    materialCostProjectList: any[];
    summaryTotal: any;
    setCompanyExpandKeys: (key: any) => void;
    checkCompanyKeyExpand: (key: any) => boolean;
    setProjectExpandKeys: (key: any) => void;
    checkProjectKeyExpand: (key: any) => boolean;
    handleScroll: (e: any, documentId: number) => Promise<void>;
}

const Table = ({
    materialCostProjectList,
    summaryTotal,
    setCompanyExpandKeys,
    checkCompanyKeyExpand,
    setProjectExpandKeys,
    checkProjectKeyExpand,
    handleScroll,
}: props) => {
    const documentId = useSelector((state: RootState) => state.cm0023.documentId);

    return (
        <div
            className="cm024-table"
            onScroll={(e: any) => {
                if (documentId) handleScroll(e, documentId);
            }}
        >
            <table>
                <thead>
                    <tr>
                        <th colSpan={2} style={{ minWidth: 150 }}>
                            No
                        </th>
                        <th
                            colSpan={2}
                            style={{ minWidth: 150, paddingLeft: 211, textAlign: 'left' }}
                        >
                            案件名
                        </th>
                        <th style={{ minWidth: 200 }}>工事名</th>
                        <th style={{ minWidth: 200 }}>支払金額(税抜)</th>
                        <th style={{ minWidth: 200 }}>消費税</th>
                        <th style={{ minWidth: 200 }}>支払金額(税込)</th>
                        <th style={{ minWidth: 40 }}></th>
                    </tr>
                </thead>
                <tbody>
                    {materialCostProjectList.map((element, index) => (
                        <CompanyRowComponent
                            key={element.id}
                            index={index}
                            data={element}
                            setCompanyExpandKeys={setCompanyExpandKeys}
                            checkCompanyKeyExpand={checkCompanyKeyExpand}
                            setProjectExpandKeys={setProjectExpandKeys}
                            checkProjectKeyExpand={checkProjectKeyExpand}
                        />
                    ))}
                </tbody>
                <tfoot>
                    <tr className="table-foot">
                        <td colSpan={2}>合計金額</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{`${helpers.formatNumberMoney(
                            summaryTotal.paymentAmountExcludeTax,
                        )}円`}</td>
                        <td>{`${helpers.formatNumberMoney(summaryTotal.taxAmount)}円`}</td>
                        <td>{`${helpers.formatNumberMoney(
                            summaryTotal.paymentAmountExcludeTax + summaryTotal.taxAmount,
                        )}円`}</td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default Table;
